import "./naf-insurance-task-banner.scss";
import nafInsuranceBlue from "assets/images/v2/naf-insurance-logo-blue.svg";
import { Button } from "components/ui/button/Button";
import { useState } from "react";
import { NAF_INSURANCE_TASKS_BANNER_CTA, NAF_INSURANCE_TASKS_BANNER_TEXT } from "utilities/Constant";
import NafInsurancePanel from "../naf-insurance-panel/NafInsurancePanel";
import { trackFSTaskInsuranceBannerGetStartedClicked } from "utilities/full-story";
import { useSelector } from "react-redux";
import { getNhDealApplicationId, getCurrentUserId } from "features/authSlice";

export default function NafInsuranceTaskBanner() {
  const [isInsuranceModalOpen, setIsInsuranceModalOpen] = useState(false);
    const nhDealAppId = useSelector(getNhDealApplicationId);
    const userId = useSelector(getCurrentUserId);
  
  const handleCtaClick = () => {
        trackFSTaskInsuranceBannerGetStartedClicked(userId, nhDealAppId);
        setIsInsuranceModalOpen(true);
  }

  return (
    <>
      <div className="naf-insurance-task-banner">
        <div className="naf-insurance-task-banner__logo"><img src={nafInsuranceBlue} alt="NAF Insurance logo" /></div>
        <div className="naf-insurance-task-banner__content">
          <div className="naf-insurance-task-banner__content-text paragraph-small-regular">
            {NAF_INSURANCE_TASKS_BANNER_TEXT}
          </div>
          <div className="naf-insurance-task-banner__content-link paragraph-small-regular">
            <Button
              type="link"
              title={NAF_INSURANCE_TASKS_BANNER_CTA}
              className="naf-insurance-task-banner__content-link-button"
              onClick={handleCtaClick}
            />
          </div>
        </div>
      </div>
      {isInsuranceModalOpen && (
        <NafInsurancePanel
          onClose={() => setIsInsuranceModalOpen(false)}
          isTaskReferral
        />
      )}
      </>
  );
}